module.exports = __webpack_public_path__ + "img/ru_img4.144c0475.png";